import React, { useRef } from "react";
import { useSelector } from "react-redux";
import Copay from "./Copay.png";
import { Link } from "react-router-dom";
import { useReactToPrint } from 'react-to-print'
import logo from "../../../assets/images/totalassist.png";
import claimGuide from "./claimGuide.pdf"

function PharmacyCard() {
  const applicationData = useSelector((state) => state.appViewDetailsSlice);
  
  const componentRef = useRef()

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <React.Fragment>
      <div ref={componentRef} style={{ margin: "5%" }}>
        <div className="intro-y box mt-lg-5">
          <div class={`intro-y box mt-lg-5 `}>
            <div class="d-flex align-items-center text-center p-5 border-bottom border-gray-200 dark-border-dark-5">
              <h2 class="fw-medium fs-base me-auto text-center">
                {applicationData.program == "CPR" ? (
                  applicationData.isPDMI
                    ? "Application Status / Pharmacy Card "
                    : "Application Status") : "Application Status"}
              </h2>
            </div>
          </div>
        </div>
        <div
          class={`intro-y box mt-lg-5 ${applicationData.viewAppInfo.appStatus == "Denied"
            ? `bg-theme-6`
            : applicationData.viewAppInfo.appStatus == "Pending"
              ? `bg-yellow`
              : applicationData.viewAppInfo.appStatus == "Approved"
                ? `bg-theme-9`
                : `bg-default`
            } text-white`}
        >
          <div class="text-center p-5 ">
            <h2 class="fw-medium fs-base me-auto text-center">
              Your Application is {applicationData.viewAppInfo.appStatus}
            </h2>
          </div>
        </div>
        <div className="intro-y box mt-lg-5 text-center">
          <div
            dangerouslySetInnerHTML={{
              __html: applicationData.applicationMessage,
            }}
          />
        </div>
        {applicationData.viewAppInfo.appStatus == "Approved" && applicationData.isPDMI && (
          <>
            <div class={`intro-y box mt-lg-5 p-2`} style={{ border: "1px solid black" }}>
              <div class="text-center p-3 ">
                <h2 class="fw-medium fs-base me-auto text-center">
                  <img src={logo} height="50px" alt="CPR_logo" />
                </h2>
              </div>
              <div class="d-flex flex-column flex-lg-row p-3 mx-n5">
                <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 pt-5 pt-lg-0">
                  <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                      Patient Name:{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.patientInfo.patientName}{" "}
                      </div>
                    </div>
                    {/* <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                      Fund :{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.viewAppInfo.fund}
                      </div>{" "}
                    </div> */}
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                      {" "}
                      Eligibility Period:{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.viewAppInfo.expiryDate} -{" "}
                        {applicationData.PDMI.effectiveDate}
                      </div>
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                      {" "}
                      Card Holder:{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.PDMI.cardHolder}
                      </div>
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                      {" "}
                      BIN:{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.PDMI.BIN}
                      </div>
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                      {" "}
                      PCN:{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.PDMI.PCN}
                      </div>
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                      {" "}
                      Group:{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.PDMI.groupNumber}
                      </div>
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                      For pharmacy inquiries contact PDMI at 855-552-0274.
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                      For patient inquiries contact PAF at 866-512-3861.
                    </div>
                  </div>
                </div>
                {/* <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 pt-5 pt-lg-0">
                  <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                      Fund :{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.viewAppInfo.fund}
                      </div>{" "}
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                      {" "}
                      Card holder: :{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.PDMI.cardHolder}
                      </div>
                    </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                      {" "}
                      PCN :{" "}
                      <div class="text-gray-600 px-2">
                        {applicationData.PDMI.PCN}
                      </div>
                    </div>

                  </div>
                </div> */}
              </div>
            </div>
            <div className="p-3">
              {applicationData.viewAppInfo.appStatus == "Approved" && applicationData.isPDMICardGenerated ? <p>For detailed instructions on the online portal expenditure process, please see TotalAssist Claim Guide. <div className="px-8 mt-1 text-center"><a href={claimGuide} target="btn verifyAddres ms-2 z-10">TotalAssist Claim Guide</a></div></p>
                : <p>For detailed instructions on the online portal expenditure process, please see TotalAssist Claim Guide. <div className="px-8 mt-1 text-center"><a href={claimGuide} target="_blank" className="btn verifyAddres ms-2 z-10">TotalAssist Claim Guide</a></div></p>}
            </div>
          </>
        )}
      </div>
      {applicationData.viewAppInfo.appStatus == "Approved" && applicationData.isPDMI && <div className="intro-y box mt-lg-5 text-center" style={{ color: "blue" }}>
        <Link className="text-center text-underline" onClick={handlePrint}>Print this out!</Link>
      </div>}
    </React.Fragment>
  );
}

export default PharmacyCard;
